<template>
  <div :class="[{ purpose: this.data?.body?.purpose }]">
    <q-linear-progress v-if="this.isFetching" indeterminate/>
    <q-form v-else @submit="this.onSubmit" class="form">
      <div class="form__item">
        <CustomInput
          label="Наименование"
          :required="true"
          :value="this.formData.project_name"
          @change_input="(value) => onChange('project_name', value)"
        />
      </div>
      <div class="form__item">
        <CustomInput
          label="Короткое Наименование"
          :value="this.formData.project_short_name"
          @change_input="(value) => onChange('project_short_name', value)"
        />
      </div>
      <div class="form__item">
        <CustomSelect
          :options="this.typeOptions"
          label="Тип проекта"
          optionValueKey="project_type_id"
          optionLabelKey="project_type_name"
          :value="this.formData.project_type_id || ''"
          @change="(value) => onChange('project_type_id', value)"
          :required="true"
          :clearable="false"
        />
      </div>
      <div class="form__item">
        <CustomSelect
          :options="this.residencyOptions"
          label="ЖК"
          optionValueKey="resident_id"
          optionLabelKey="resident_name"
          :value="this.formData.resident_id || ''"
          @change="(value) => onChange('resident_id', value)"
          :required="true"
          :clearable="false"
        />
      </div>
      <div class="form__item">
        <CustomSelect
          label="Подъезды"
          :options="this.entranceOptions"
          optionValueKey="entrance"
          optionLabelKey="entrance"
          :value="this.formData.entrances || ''"
          @change="(value) => onChange('entrances', value)"
          :multiple="true"
          :required="true"
        />
      </div>

      <div class="form__item form__item_date">
        <span>Дата начала</span>
          <CustomDate
            :fullWidth="true"
            :value="this.formData.start_date"
            @change_date="(value) => onChange('start_date', value)"
            :required="true"
            />
        </div>
        <div class="form__item form__item_date">
          <span>Дата окончания *</span>
          <CustomDate
            :fullWidth="true"
            :value="this.formData.finish_date"
            @change_date="(value) => onChange('finish_date', value)"
            :required="true"
          />
        </div>
        <div class="form__item">
          <CustomInput
            type="number"
            label="Сумма аванса"
            :value="this.formData.avans"
            @change_input="(value) => onChange('avans', value)"
          />
        </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import {
  getEntranceOptions,
} from "@/views/FlatList/services";
import { getProjectTypes } from "@/views/ShellProjects/services";
import CustomDate from "@/components/form/CustomDate";
import { getCommonResidents } from "@/views/FastSearch/services";

export default {
  name: "upd-shl-projects",
  components: { CustomInput, CustomSelect, CustomModalFooter, CustomDate },
  props: ["data"],
  data() {
    return {
      loading: false,
      isFetching: false,
      residencyOptions: [],
      entranceOptions: [],
      typeOptions: [],
      formData: {
        project_id: this.data?.body?.project_id || "",
        project_name: this.data?.body?.project_name || "",
        project_short_name: this.data?.body?.project_short_name || "",
        project_type_id: this.data?.body?.project_type_id || "",
        resident_id: this.data?.body?.resident_id || "",
        entrances: this.data?.body?.entrances || [],
        start_date: this.data?.body?.start_date || "",
        finish_date: this.data?.body?.finish_date || "",
        avans: this.data?.body?.avans
        ? Number(this.data.body.avans.toString().replace(/\s/g, ""))
        : "",
      },
    };
  },
  async mounted() {
    this.isFetching = true;
    
    await this.getProjectTypes();
    await this.getResidentsOptions();
    
    if (this.formData.resident_id) {
      await this.getEntranceOptions(this.formData.resident_id);
    }
    
    this.isFetching = false;
  },
  methods: {
    async getProjectTypes() {
      const res = await getProjectTypes();
      this.typeOptions = res || [];
    },
    async getResidentsOptions() {
      const res = await getCommonResidents();
      this.residencyOptions = res || [];
    },
    async getEntranceOptions(resident_id) {
      const res = await getEntranceOptions(resident_id);
      this.entranceOptions = res || [];
      if (!this.entranceOptions.length) {
        this.formData.entrances = [];
      }
    },
    async onChange(key, value) {
      this.formData[key] = value;
      if (key === "resident_id" && value === "") {
        this.entranceOptions = [];
        this.formData.entrances = "";
        return;
      }
      if (key === "resident_id" && value !== "") {
        this.isFetching = true;
        const res = await getEntranceOptions(this.formData.resident_id);
        this.entranceOptions = res || [];
        this.formData.entrances = [];
        if (!this.entranceOptions.length) {
          this.formData.entrances = [];
        }
        this.isFetching = false;
      }
      return;
    },
    async onSubmit() {
      this.loading = true;
      
      await this.data?.onSubmit(this.formData);
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  gap: 20px;

  @media (max-width: 428px) {
    min-width: 100%;
  }
}
.form__item_date {
  display: flex;
  flex-direction: column;

}
.form__item_date span {
  font-size: 12px;
  padding-left: 1px;
  color: gray;
}
</style>
